import { useState } from "react";
import axios from 'axios';

export const useFormSubmit = (url: string, accept?: ("text/plain" | "application/json")) : readonly[(body:any) => void, any, boolean | undefined, string | undefined] => {
    const [data, setData] = useState(undefined as any);
    const [loading, setLoading] = useState(undefined as boolean | undefined);
    const [error, setError] = useState(undefined as string | undefined);

    const submitForm = (body? :any) => {
        setLoading(true)
        setData(undefined);
        setError(undefined);
        const promise = axios.post(`${window.location.origin}/api/${url}`, body, {  
            headers: {
            "Accept": accept??"application/json",
            'Content-Type': 'multipart/form-data'
            }
        });

        promise.then(res => {
            setLoading(false);
            //checking for multiple responses for more flexibility 
            //with the url we send in.
            console.log("Response", res.data);
            res.data && setData(res.data);
        })
        .catch(err => {
            setLoading(false)
            setError(JSON.stringify(err))
        })
    };

    return [submitForm, data, loading, error] as const;
}